import { AdditionalInfoImpl } from './additional-info-impl';

export class TicStatus extends AdditionalInfoImpl {
  validator1: string;
  validator2: string;
  validator3: string;
  validator4: string;
  validator5: string;
  validator6: string;
  validator7: string;
  validator8: string;
  validator9: string;
  validator10: string;
}
